<template>
  <div class="credit-info">
    <h2>{{ title }}</h2>
    <div class="column-wrapper">
      <div class="column light">
        <h3>-Light-</h3>
        <p v-for="content in contents.light" :key="content.title">
          『{{ content.title }}』<br />{{ content.artist }}
        </p>
      </div>
      <div class="column dark">
        <h3>-Dark-</h3>
        <p v-for="content in contents.dark" :key="content.title">
          『{{ content.title }}』<br />{{ content.artist }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CreditInfo",
  props: {
    title: {
      type: String,
      default: "None",
    },
    contents: {
      type: Object,
      default: undefined,
    },
  },
};
</script>
<style scoped lang="scss">
.credit-info{
    @media (max-width: 600px) {
        font-size: 0.8em;
    }
}
h2{
    border-bottom: solid;
    padding: 1%;
    border-width: 1px;
    margin-bottom: 5%;
}
.column-wrapper {
  align-items: center baseline;
  justify-content: center;
  display: flex;
}
.column {
  width: 50%;
  height: 100%;
  p {
      margin: 5%;
  }
}
</style>
